import React, { useEffect, useState } from "react";
import { Button, ListItem, ListItemSecondaryAction } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { useIntl } from "react-intl";
import { displayUser } from "../../../../../Utils/User";
import { User } from "../../../../../Models/User";
import { useStyles } from "./RenderOption.style";
import {
  UserRoleType,
  UserStatusType,
} from "../../../../../generated/user-api";
import { messages } from "./RenderOption.messages";
import {
  useCustomerFeatures,
  useCustomerId,
} from "../../../../../Providers/CustomerProvider/CustomerProvider";
import { hasFeatureEnabled } from "../../../../FeatureController/FeatureController";
import { CustomerFeatureType } from "../../../../../generated/customersettings-api";
import { userService } from "../../../../../Providers/ServiceProvider/ServiceProvider";
import { useAuthenticatedUser } from "../../../../../Providers/AuthenticatedUserProvider/AuthenticatedUserProvider";

export interface Option extends User {
  isNewUser?: boolean;
}

interface Props {
  option: Option;
  onCreateUser: (personNumber: string) => void;
  onExistingUser: (user: User) => void;
  role?: UserRoleType;
}

const RenderOption = (props: Props) => {
  const { option, role, onCreateUser, onExistingUser } = props;
  const intl = useIntl();
  const customerId = useCustomerId();
  const [authenticatedUser] = useAuthenticatedUser();
  const classes = useStyles();
  const [existingUser, setExistingUser] = useState<User>();
  const customerFeatures = useCustomerFeatures();
  const doFormatPersonNumber = hasFeatureEnabled(
    CustomerFeatureType.UsesPersonNumber,
    customerFeatures
  );

  const checkIfUserExists = () => {
    if (customerId && authenticatedUser.user && option.isNewUser && role) {
      userService()
        .listUsersByCustomerAndSearchParamsDecorated(authenticatedUser.user, {
          personNumber: option.personNumber,
          customerId,
          userStatus: UserStatusType.Active,
          userRole: role,
        })
        .then((res) => {
          if (res.data?.length === 1) {
            setExistingUser(res.data[0]);
          }
        });
    }
  };

  useEffect(() => {
    checkIfUserExists();
  }, [option]); // eslint-disable-line react-hooks/exhaustive-deps

  if (role && option.isNewUser && existingUser) {
    return (
      <ListItem
        key={option.personNumber}
        className={classes.listItem}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ListItemSecondaryAction>
          <Button
            color="secondary"
            variant="outlined"
            aria-label={intl.formatMessage(messages.buttonLabel)}
            startIcon={<AddIcon />}
            onClick={() => onExistingUser(existingUser)}
          >
            {intl.formatMessage(messages.buttonLabel)}
          </Button>
        </ListItemSecondaryAction>
        {option.personNumber}
      </ListItem>
    );
  }

  if (role && option.isNewUser && !existingUser) {
    return (
      <ListItem
        key={option.personNumber}
        className={classes.listItem}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ListItemSecondaryAction>
          <Button
            color="secondary"
            variant="outlined"
            aria-label={intl.formatMessage(messages.buttonLabel)}
            startIcon={<AddIcon />}
            onClick={() => onCreateUser(option?.personNumber || "")}
          >
            {intl.formatMessage(messages.buttonLabel)}
          </Button>
        </ListItemSecondaryAction>
        {option.personNumber}
      </ListItem>
    );
  }

  return (
    <ListItem key={option.id} className={classes.listItem}>
      {displayUser(doFormatPersonNumber, option)}
    </ListItem>
  );
};

export default RenderOption;
